/**
 * Validates if a string contains XSS (Cross-Site Scripting) patterns
 * @param input - The string to check
 * @returns true if the string contains XSS patterns, false otherwise
 */
export function containsXss(input: string): boolean {
  if (!input || typeof input !== "string") {
    return false;
  }

  const dangerousPatterns = [
    /<[^>]*>?/i, // HTML tags (including incomplete ones)
    /&lt;[^&]*&gt;/i, // HTML entities forming tags
    /javascript:|vbscript:|data:/i, // Dangerous protocols
    /on\w+\s*=/i, // Event handlers (onclick, onload, etc.)
    /<\s*\/?(?:script|iframe|object|embed|link|style|meta|svg|img|form|input)\b/i, // Dangerous HTML tags
    /eval\s*\(|expression\s*\(/i, // Dangerous functions
    /&#(?:60|62|x3[ce]);/i, // Specific dangerous HTML entities: < (&#60;) > (&#62;)
    /document\.|window\.|alert\s*\(|confirm\s*\(|prompt\s*\(/i, // DOM/Window access
    /<!--[\s\S]*?-->/i, // HTML comments
    /<!\[CDATA\[[\s\S]*?\]\]>/i, // CDATA sections
  ];

  return dangerousPatterns.some((pattern) => pattern.test(input));
}
